<template>
        <form @submit.prevent="submit($event)" id="searchcontracts-signcontract">
            <h1 class="searchcontracts__title searchcontracts_start" style="display:none;">Teckna elavtal direkt</h1>
    <boraselhandel-component-searchcontracts class="searchcontracts_start" style="display:none;">
        <div class="col">
            <label class="title">Postnummer</label>
            <input type="number" v-model="$root.searchPostalCode" id="postalcode" size="5" maxlength="5" class="textinput numberinput" />
        </div>
        <div class="col">
            <label class="title">Förbrukning</label>
        <datalist id="consumptionlist">
        <option value="2000">2000 kWh/år (Lägenhet)</option>
        <option value="5000">5000 kWh/år (Mindre villa)</option>
        <option value="20000">20&nbsp;000 kWh/år (Större villa)</option>
        </datalist>
            <input list="consumptionlist" v-model="$root.searchConsumption"  type="number" id="consumption" size="5" maxlength="5" class="textinput" autocomplete="off" />
        </div>
        <!--<div class="col hidetextonsmall">
            <label class="title">Inflyttning?</label>
            Nej
            <label class="switch">
                <input type="checkbox" v-model="$root.searchMovingIn" @change='changeContractStartDateLimit()'>
                <span class="slider round"></span>
            </label>
            Ja
        </div>-->
        <div class="col">
            <label class="title">Startdatum</label>
            <div class="dateinputarea">
                <input type="date" id="contractstartdate" v-model="$root.searchStartDate" size="10" maxlength="10" class="textinput dateinput searchcontractsstartdate" placeholder="Startdatum" />
                <!--<div class="dateinputicon"><i class="fa-solid fa-calendar"></i></div>-->
            </div>
        </div>
        <div class="col actionbutton">
            <button type="submit" class="button button--with-icon" v-on:click="$root.trackClickEvent('cta_sok_steg1')">Sök <Arrow /></button>
        </div>
    </boraselhandel-component-searchcontracts>
</form>
</template>

<script>
import axios from 'axios';
function pad(value) {
  const _value = parseInt(value, 10);
  return (_value < 10 && _value > 0) ? '0' + _value : value;
}    
    export default {
      methods: {
        dateText (dt) {
            let text = '';
            if (dt && (dt instanceof Date)) {
                text = [dt.getFullYear(), pad(dt.getMonth() + 1), pad(dt.getDate())].join('-');
            }
            return text;
        },
        changeContractStartDateLimit() {
        
            var now = new Date();
            var dateInput = document.getElementsByClassName('searchcontractsstartdate')[0];
            dateInput.min = this.dateText(this.getDate());
            dateInput.max = this.dateText(new Date(now.getFullYear(), now.getMonth() + 4, 2));
        },
        getNumberOfOrdinaryDaysBetweenTwoDates(startdate, enddate) {
            var d = new Date(startdate);
            
            var c = 0;
            
            while (d < enddate) {

                const dayOfWeek = d.getDay();
                
                if (dayOfWeek >= 1 && dayOfWeek < 6) {
                    c++;
                }
            
                d.setDate(d.getDate() + 1);			
            }
            
			return c;
        },
        getDate() {
            var openingDate = new Date();
            var now = new Date();
                                                              
            /*
            if(this.$root.searchMovingIn) {

                openingDate = new Date(now.getFullYear(), now.getMonth(), now.getDate()+5); // Today + 5 days

            } else {
                openingDate = new Date(now.getFullYear(), now.getMonth(), now.getDate()+21); // Today + 21 days;
                
                if (openingDate.getDate() > 1) {
                    openingDate = new Date(openingDate.getFullYear(), openingDate.getMonth() + 1, 1); // go to next month directly!
                }
                
            }
            */

            openingDate = new Date(now.getFullYear(), now.getMonth(), now.getDate()+3); // Today +3 days

            return openingDate;
        },
        getNumberText(txt) {
            if (!txt)
                return '';

            let s = '';

            for (let i = 0; i < txt.length; i++) {
                let c = txt[i];

                if (c >= '0' && c <= '9') {
                    s += c;
                }
            }

            return s;
        },
        updateValidity(id, txt) {
            document.getElementById(id).setCustomValidity(txt);
            document.getElementById(id).checkValidity();
            document.getElementById(id).reportValidity();
            //document.getElementById(id).setCustomValidity('');
        },
        checkValidity() {
            console.log ('go');
            // TODO: Check so postalCode is 5 numbers, consumption, startdate
            this.updateValidity('postalcode', '');
            this.updateValidity('consumption', '');
            this.updateValidity('contractstartdate', '');

            let postalCode = this.getNumberText(this.$root.searchPostalCode);

            let r = true;

            if (postalCode.length != 5) {
                this.updateValidity('postalcode', "Felaktigt postnummer. Fyll i fem (5) siffror.");
                console.log ("postalCode error: " + this.$root.searchPostalCode + " ==> " + postalCode);
                r = false;
            }
           

            let consValue = 0;
            try {
                consValue = parseInt(this.$root.searchConsumption);
            } catch {
                consValue = 0;
            }

            if (consValue <= 0 || isNaN(consValue)) {
                this.updateValidity('consumption', "Förbrukning saknas eller är felaktig.");
                console.log ("consValue error: " + this.$root.searchConsumption + " ==> " + consValue);
                r = false;
            }

            let st = null;
            try {
                st = new Date(this.$root.searchStartDate);
            } catch {
                st = null;
            }

            if (st == null) {
                this.updateValidity('contractstartdate', "Felaktigt datum.");

                console.log ("startdate error: " + this.$root.searchStartDate + " ==> null");
                r = false;
            }

            let isValidDate = st instanceof Date && !isNaN(st);

            if (!isValidDate) {
                this.updateValidity('contractstartdate', "Felaktigt datum.");
                console.log ("startdate error: " + this.$root.searchStartDate + " ==> isValidDate:" + isValidDate);
                r = false;
            }

            return r;
        },
        submit() {

            if (!this.checkValidity()) {
                return false;
            }

            this.$root.contract.date = this.$root.searchStartDate;
            this.$root.contract.postal = this.$root.searchPostalCode;
            this.$root.start = this.$root.searchStartDate;
            this.$root.direct_watts = this.$root.searchConsumption;
            this.$root.postal_code = this.$root.searchPostalCode;

            this.$root.area_possible = true;

            //this.$root.contract.area = this.$root.getPriceAreaForPostalCode(this.$root.contract.postal); // Set area code for postal

            let curThis = this;

            curThis.$root.getPriceAreaForPostalCodeUsingApi(curThis.$root.contract.postal, function (ret) {

                curThis.$root.contract.area = ret;
                //alert (this.$root.contract.postal + " - area: " + this.$root.contract.area);

                curThis.$root.loadContracts();

                fetch('https://api.energiinfo.se/SubmitContract/2.6/api/v1/spotprices/' + curThis.$root.contract.area + '/lastmonth').then(r => r.json()).then(r => {
                    curThis.$root.spotprice_lastmonth = r;

                    if(r.message){
                        curThis.$root.noPostalCodeFound = true;
                        axios.post(curThis.$root.publicUrl + "/api/mailpostalcode.php", JSON.stringify(curThis.$root.$data));
                    }

                    curThis.$root.tagSetEditMode('contractselection');

                    if (curThis.$root.flowString.indexOf('searchcontracts') < 0) {
                        curThis.$root.flowString += 'searchcontracts';
                    }                
                });

                fetch('https://api.energiinfo.se/SubmitContract/2.6/api/v1/price/14/' + curThis.$root.contract.area + '/?dt=' + curThis.$root.start).then(r => r.json()).then(r => {

                    if (r && r.length > 0) {
                        const volumeCostDef = r.filter(x => x.label == "Volymkostnad");

                        if (volumeCostDef != null && volumeCostDef.length > 0) {
                            curThis.$root.additionalcosts_volumeCost = parseFloat(volumeCostDef[0].price);
                        }
                    }


                });

            });


        }
      },
      created() {
      },
      mounted() {
        this.changeContractStartDateLimit();

        document.getElementById('postalcode').addEventListener('keyup', function (ev) {
                ev.target.setCustomValidity('');
        });

        document.getElementById('consumption').addEventListener('keyup', function (ev) {
                ev.target.setCustomValidity('');
        });
  
        document.getElementById('contractstartdate').addEventListener('keyup', function (ev) {
                ev.target.setCustomValidity('');
        });
        
        document.getElementById('contractstartdate').addEventListener('change', function (ev) {
                ev.target.setCustomValidity('');
        });

        let curThis = this;
        let postalCodeElement = document.getElementById('postalcode');

        postalCodeElement.onkeyup = function () { //evt) {
            //evt = evt || window.event;
            postalCodeElement.value = curThis.getNumberText(postalCodeElement.value);
/*
            if (evt.key >= '0' && evt.key <= '9') {
                return true;
            }

            return false;
            */
           return true;
        }

        // Get from query
        let postalCodeStart = this.$root.getParameterValue('postalcode');
        let consumptionStart = this.$root.getParameterValue('consumption');
        let startDate = this.$root.getParameterValue('startdate');

        if (!this.$root.searchcontract_start && postalCodeStart != '' && consumptionStart != '' && startDate != '') {
            this.$root.searchPostalCode = postalCodeStart;
            this.$root.searchConsumption = consumptionStart;
            this.$root.searchStartDate = startDate;

            this.$root.searchcontract_start = true;
            this.submit();
        } else {

            let elems = document.getElementsByClassName('searchcontracts_start');
            for (let i = 0; i < elems.length; i++) {
                elems[i].style.display = 'block';
            }
         }

      }
    }
</script>
<style lang="scss">
.searchcontracts__title {
    text-align: center;
  }
</style>